<template>
  <div class="FileUploaderSearchBar">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc text-align-left font-size-18px">
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0Point2Perc padding-right-0px width-7Perc">
          Search
        </div>
        <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 text-align-left">
          <div class="row vertical-align">
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-right-17Perc margin-left-3px margin-right-10px">
              <div class="form-group margin-bottom-0px">
                <div class="icon-addon addon-lg">
                  <input type="text" ref="input" class="form-control background-gray border-rounded" v-model="enteredTextInSearch" autocomplete="off"/>
                  <label class="glyphicon glyphicon-search"></label>
                </div>
              </div>
            </div>
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 left-border padding-left-3Perc">  
              <button type="button" class="btn black-border custom-btn white-BG" @click="updateOpenFileUploadOverlay($event)">+ Upload</button>
            </div>
          </div>   
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
      </div>     
    </div>
    <upload-file-overlay v-if="showUploadFileOverlay" @closeOverlay="HideFileUploadOverlay" @refreshList="refreshList"></upload-file-overlay>
  </div>
</template>
<script>
import resetIcon from '../assets/images/reset.svg'
import UploadFileOverlay from '@/components/UploadFileOverlay'
export default{
  data: function () {
    return {
      showUploadFileOverlay: false,
      enteredTextInSearch: '',
      reset: resetIcon
    }
  },
  methods: {
    refreshList (value) {
      // AK: Re-emit refresh call to parent (FileUploader file)
      this.$emit('refreshList', true)
    },
    updateOpenFileUploadOverlay () {
      // AK: Used when user pressed Uplaod file option
      this.showUploadFileOverlay = true
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
    },
    HideFileUploadOverlay (value) {
      // AK: Used to hide upload file overlay
      this.showUploadFileOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    showResults: function () {
      var obj = this.findBy(this.getAllFilesValues, this.enteredTextInSearch, 'FileName')
      this.$emit('searchResults', obj)
    },
    findBy: function (list, value, column) {
      return list.filter(function (item) {
        // return item[column].includes(value)
        // return item[column].indexOf(value) !== -1
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    },
    resetFilterAndList: function () {
      this.enteredTextInSearch = ''
      this.$emit('searchResults', this.getAllFilesValues)
    }
  },
  computed: {
    getAllFilesValues: {
      get: function () {
        return this.$store.state.fileRepositoryList
      }
    }
  },
  components: {
    'upload-file-overlay': UploadFileOverlay
  },
  watch: {
    enteredTextInSearch: function () {
      var obj = this.findBy(this.getAllFilesValues, this.enteredTextInSearch, 'FileName')
      this.$emit('searchResults', obj)
    }
  },
  name: 'FileUploaderSearchBar'
}
</script>

<style scoped>
.FileUploaderSearchBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}
.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}
.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}
.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}
.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}
.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}
.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.black-border {
  border: 1px solid #aaa;
}
.left-border {
  border-left: 1px solid #aaa;
}
.padding-right-3Perc{
    padding-right: 3% !important;
}
.padding-Left-2Point6Perc{
    padding-left: 2.6% !important;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-0Point5Perc
{
	margin-top: 0.5%;
}
.margin-Top-1Perc
{
	margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}

.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.margin-Left-3Perc
{
  margin-left: 3%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.font-size-18px{
    font-size: 18px;
}
.padding-left-0Perc{
 padding-left:0%;
}
.padding-left-3Perc{
 padding-left:3%;
}
.padding-left-0Point2Perc{
 padding-left:0.2%;
}
.padding-left-1Perc{
 padding-left:1%;
}
.padding-right-0Perc{
 padding-right:0%;
}
.padding-right-0px{
 padding-right:0px;
}
.padding-right-17px{
 padding-right:17px;
}
.width-12Perc{
  width:12%;
}
.margin-left-3px{
  margin-left:3px !important;
}
.img-opacity{
  opacity:0.7;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-bottom-0px{
  margin-bottom: 0%;
}
.width-10px{
width:5%;
}
.padding-right-2Point5Perc{
  padding-right:2.5%; 
}
.width-7Perc{
  width:7%;
}
.margin-right-10px{
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploaderSearchBar.vue